const QuizData = {
  EN: {

    HARD: [
      {
        "id": 0,
        "title": "Can you drink the water from the canals?",
        "answers": [
          {
            "title": "Yes",
            "correct": false
          },
          {
            "title": "No",
            "correct": true
          }
        ],
        "extra": "Although the canal water has become cleaner over the centuries, it is still not clean enough to drink. The construction of sewage systems, pumping stations and sluices ensure a constant flow of water through the canals."
      },
      {
        "id": 1,
        "title": "Is the water in the canals fresh or salty?",
        "answers": [
          {
            "title": "Fresh",
            "correct": false
          },
          {
            "title": "Salty",
            "correct": false
          },
          {
            "title": "Both answers are correct",
            "correct": true
          }
        ],
        "extra": "The water is both fresh and salty! This is also known as 'brackish water'. The canals are connected to the North Sea Channel via the IJ, allowing saltwater to enter the canals from the lock at IJmuiden.  This makes it extra attractive for animal and fish species."
      },
      {
        "id": 2,
        "title": "How many species of fish live in the canals of Amsterdam?",
        "answers": [
          {
            "title": "65",
            "correct": true
          },
          {
            "title": "45",
            "correct": false
          },
          {
            "title": "33",
            "correct": false
          },
          {
            "title": "51",
            "correct": false
          }
        ],
        "extra": "There are fish that live in the salt water, in the fresh water and in the brackish water. Additionally, the canal water attracts many birds that use the city as a feeding area. Notable new residents of the canals are the great crested grebe and the Eurasian coot. They feed on fish, plants and mussels, which indicates that the canals can provide sufficient food."
      },
      {
        "id": 3,
        "title": "Approximately how many kilograms of plastic does Waternet remove from the canals of Amsterdam each year? ",
        "answers": [
          {
            "title": "Between 20,000 and 30,000 kilograms",
            "correct": false
          },
          {
            "title": "Between 40,000 and 60,000 kilograms",
            "correct": true
          },
          {
            "title": "Between 70,000 and 90,000 kilograms",
            "correct": false
          },
          {
            "title": "Between 90,000 and 110,000 kilograms",
            "correct": false
          }
        ],
        "extra": "Waternet, Water Authority Amstel, Gooi and Vecht and the Municipality of Amsterdam ensure that the water in the canals remains clean. Partly because of this, Amsterdam and its canals now offer a remarkably rich biodiversity. But organizations like Plastic Whale also contribute to cleaner canals."
      },
      {
        "id": 4,
        "title": "What animals are also known as the city's garbage collectors?",
        "answers": [
          {
            "title": "Seagulls",
            "correct": false
          },
          {
            "title": "Rose-ringed parakeet",
            "correct": false
          },
          {
            "title": "Eurasian coot",
            "correct": true
          }
        ],
        "extra": "Unlike the seagulls that tear up garbage bags on the street and spread waste, it's the coots that uses trash from the canals to build their nests."
      },
      {
        "id": 5,
        "title": "The Municipality of Amsterdam aims for a fixed surface water level in the canals (city centre). How high, or low, is this water level?",
        "answers": [
          {
            "title": "1.8 meters below NAP ",
            "correct": false
          },
          {
            "title": "0.4 meters below NAP ",
            "correct": true
          },
          {
            "title": "0.7 meters below NAP ",
            "correct": false
          },
          {
            "title": "3.4 meters below NAP ",
            "correct": false
          }
        ],
        "extra": "The correct answer is 0.4m below NAP. This is approximately the ideal water level for everyone.  This is very important. A water level that is too high can lead to wet feet, but if the water level is too low, there is a risk that the foundation piles will become dry and start rotting."
      },
      {
        "id": 6,
        "title": "What animal is not found in the canals?",
        "answers": [
          {
            "title": "Lobster",
            "correct": false
          },
          {
            "title": "Salmon",
            "correct": false
          },
          {
            "title": "Toads",
            "correct": true
          }
        ],
        "extra": "Due to climate change, there is a significant food shortage for wildlife. As a result, the city attracts exotics: plants, animals, or other organisms that do not naturally occur in the area where they are found. Ultimately, for many animals, the city is as appealing as a forest or wilderness."
      },
      {
        "id": 7,
        "title": "Certain rules apply to a considerable number of canal gardens to keep them as green as possible. What are these rules called?",
        "answers": [
          {
            "title": "Green regulations",
            "correct": false
          },
          {
            "title": "Approval regulations",
            "correct": true
          },
          {
            "title": "Tree regulations",
            "correct": false
          }
        ],
        "extra": "Thanks to the 17th-century approval regulations the greenery in the canal belt has been preserved, allowing us to enjoy it every day! The protected gardens are located in the so-called inspection blocks. In total there are 27 inspection blocks. It was strictly forbidden to place industries or large buildings in the garden area. The gardens have enjoyed special legal protection since 1615."
      },
      {
        "id": 8,
        "title": "In addition to the trees in the canal gardens, there are also plenty of trees on the canal belt. What kind of trees are these?",
        "answers": [
          {
            "title": "Oak",
            "correct": false
          },
          {
            "title": "Linden",
            "correct": false
          },
          {
            "title": "Elms",
            "correct": true
          }
        ],
        "extra": "These are Amsterdam elms! The trees are becoming increasingly important to keep the city liveable. Elms are suitable for many soil types and the tree can survive well in the city. More greenery in the city provides cooling, greater biodiversity and more oxygen."
      },
      {
        "id": 9,
        "title": "What adaptations does the municipality make for animals in the city?",
        "answers": [
          {
            "title": "Placing shrubs, marsh and water plants during quay work",
            "correct": false
          },
          {
            "title": "Planting ferns and aquatic plants to attract insects",
            "correct": false
          },
          {
            "title": "Installing bat cavities under bridges",
            "correct": false
          },
          {
            "title": "All answers are correct",
            "correct": true
          }
        ],
        "extra": "This swan built its nest here, between the temporary sheet piles in the middle of a special piece of nature on the canals. But this nature did not flourish on its own: shrubs, fish baskets and marsh and water plants have been planted."
      }
    ]


    // [{ "id": 0, "title": "Which fish could never be found in the canals of Amsterdam?", "answers": [{ "title": "A tuna", "correct": true }, { "title": "An eel", "correct": false }, { "title": "A zander", "correct": false }, { "title": "A salmon", "correct": false }], "extra": "" }, { "id": 1, "title": "Approximately how many kilograms of plastic does Waternet remove from the canals of Amsterdam each year?", "answers": [{ "title": "Between 20,000 and 30,000 kilograms", "correct": false }, { "title": "Between 40,000 and 60,000 kilograms", "correct": true }, { "title": "Between 70,000 and 90,000 kilograms", "correct": false }, { "title": "Between 90,000 and 110,000 kilograms", "correct": false }], "extra": "" }, { "id": 2, "title": "The municipality of Amsterdam aims for a standard water level in the canals. How high, or low, is this water level?", "answers": [{ "title": "1.8 meters below sea level", "correct": false }, { "title": "0.4 meters below NAP", "correct": true }, { "title": "0.7m above NAP", "correct": false }, { "title": "3.4m above sea level", "correct": false }], "extra": "The correct answer is 0.4m below NAP. This is approximately the ideal water level for everyone. This is very precise. A water level that is too high will cause flooding, but a water level that is too low may cause the foundation piles to dry out and therefore rot." }, { "id": 3, "title": "How can you tell that Amsterdam's canals are getting cleaner?", "answers": [{ "title": "Plants are growing in and around the water of the canals", "correct": false }, { "title": "The water is less turbid than it used to be", "correct": false }, { "title": "Many different kinds of fish live in the water", "correct": false }, { "title": "All the answers above are correct", "correct": true }], "extra": "" }, { "id": 4, "title": "In which year was all of Amsterdam connected to the sewer system for the first time?", "answers": [{ "title": "1930", "correct": false }, { "title": "2017", "correct": true }, { "title": "1870", "correct": false }], "extra": "" }, { "id": 5, "title": "What is a Water Level Ordinance?", "answers": [{ "title": "A decision by Rijkswaterstaat and the Water Authority, made once every ten years, about the ideal water level for everyone in an area", "correct": true }, { "title": "A decision by municipalities in a crisis, that drastic steps have to be taken to lower the water level", "correct": false }, { "title": "A decision by the Water Authority, at which level the emergency plan should go into effect", "correct": false }, { "title": "A decision by the State, in which the water level in each province is gauged", "correct": false }], "extra": "Water Level Ordinances are made about once every ten years. In this process, the executive bodies of Rijkswaterstaat and the Water Authorities discuss the right water level with all parties involved. In the canal belt of Amsterdam, a summer and winter level of 0.4m below NAP has been in force since 2008." }, { "id": 6, "title": "Sometimes the sewage in Amsterdam mixes with the water in the canals. Why is that?", "answers": [{ "title": "There are still houses in Amsterdam that have their sewage pipes run directly into the canals", "correct": false }, { "title": "The sewage system occasionally becomes too full when too many people flush their toilets at the same time", "correct": false }, { "title": "If it has been raining hard, the sewage system cannot cope and there is no other option but to discharge the water via an overflow into the canals", "correct": true }, { "title": "All three answers are correct", "correct": false }], "extra": "After heavy rain, too much water flows into the sewers and then mixes with polluted water from houses. Because the biggest nightmare is that the water rises in toilets, some of it is discharged into the canals. This often happens in the summer. Purification takes about three days." }, { "id": 7, "title": "Approximately how deep is the average canal in Amsterdam?", "answers": [{ "title": "Between one and two meters", "correct": false }, { "title": "Between two and three meters", "correct": true }, { "title": "Between three and four meters", "correct": false }, { "title": "It varies, so not much can be said about it", "correct": false }], "extra": "" }, { "id": 8, "title": "Amsterdam\u2019s canal houses stand on wooden foundation piles. But there's also the sewage system... How does that work?", "answers": [{ "title": "It is always quite a puzzle to fit the sewage pipes through the wooden foundation piles", "correct": false }, { "title": "The wooden foundation piles are generally lower than the sewer pipes, and therefore they seldom cross each other", "correct": true }, { "title": "The sewer pipes are generally lower than the wooden foundation piles, and therefore they seldom cross each other", "correct": false }, { "title": "It depends on the sand layer on which the piles rest whether the sewer pipes are placed between them or on top of them", "correct": false }], "extra": "" }, { "id": 9, "title": "Which pumping stations and sluices are needed to maintain the right water levels in Amsterdam?", "answers": [{ "title": "IJburg pumping station", "correct": false }, { "title": "IJmuiden pumping station", "correct": false }, { "title": "The sluice under the Waag", "correct": false }, { "title": "All three answers are correct", "correct": true }], "extra": "" }]
  },
  NL: {

    HARD: [
      {
        "id": 0,
        "title": "Kan je het water uit de grachten drinken?",
        "answers": [
          {
            "title": "Ja",
            "correct": false
          },
          {
            "title": "Nee",
            "correct": true
          }
        ],
        "extra": "Hoewel het grachtenwater door de eeuwen heen schoner is geworden, is het nog niet schoon genoeg om te drinken. De aanleg van riolering, gemalen en sluizen zorgen voor een constante doorstroom van water door de grachten."
      },
      {
        "id": 1,
        "title": "Is het water in de grachten zoet of zout?",
        "answers": [
          {
            "title": "Zoet",
            "correct": false
          },
          {
            "title": "Zout",
            "correct": false
          },
          {
            "title": "Beide antwoorden zijn juist",
            "correct": true
          }
        ],
        "extra": "Het water is zowel zoet als zout! Dit wordt ook wel ‘brak’ genoemd. De grachten staan via het IJ in verbinding met het Noordzeekanaal. Dus vanaf de sluis bij IJmuiden komt er zoutwater in de grachten. Hierdoor is het extra aantrekkelijk voor dier- en vissoorten."
      },
      {
        "id": 2,
        "title": "Hoe veel vissoorten leven er in de Amsterdamse grachten?",
        "answers": [
          {
            "title": "65",
            "correct": true
          },
          {
            "title": "45",
            "correct": false
          },
          {
            "title": "33",
            "correct": false
          },
          {
            "title": "51",
            "correct": false
          }
        ],
        "extra": "Er zijn vissen die leven in het zoute water, in het zoete water en in het brakke water. Verder trekt het grachtenwater ook veel vogels aan die de stad gebruiken als voedselgebied. Opvallende nieuwe bewoners van de grachten zijn de fuut en de meerkoet. Zij voeden zich met vis, planten en mossels, wat aangeeft dat de grachten voldoende voedsel kunnen bieden."
      },
      {
        "id": 3,
        "title": "Hoeveel kilogram plastic haalt Waternet jaarlijks ongeveer uit de Amsterdamse grachten?",
        "answers": [
          {
            "title": "Tussen de 20.000 en 30.000 kilogram ",
            "correct": false
          },
          {
            "title": "Tussen de 40.000 en 60.000 kilogram ",
            "correct": true
          },
          {
            "title": "Tussen de 70.000 en 90.000 kilogram",
            "correct": false
          },
          {
            "title": "Tussen de 90.000 en 110.000 kilogram",
            "correct": false
          }
        ],
        "extra": "Waternet, het Waterschap Amstel, Gooi en Vecht en de Gemeente Amsterdam zorgen ervoor dat het water in de grachten schoon blijft. Mede daardoor bieden Amsterdam en haar grachten tegenwoordig een opvallend rijke biodiversiteit. Maar ook organisaties als Plastic Whale zorgen voor schonere grachten."
      },
      {
        "id": 4,
        "title": "Welke dieren worden ook wel de vuilnismannen van de stad genoemd?",
        "answers": [
          {
            "title": "Meeuwen",
            "correct": false
          },
          {
            "title": "Halsbandparkiet",
            "correct": false
          },
          {
            "title": "Meerkoet",
            "correct": true
          }
        ],
        "extra": "In tegenstelling tot de meeuwen die vuilniszakken op straat kapot maken en afval verspreiden, zijn het de meerkoeten die afval uit de grachten gebruiken om een nestje van te maken."
      },
      {
        "id": 5,
        "title": "Door de Gemeente Amsterdam wordt gestreefd naar een vast oppervlaktewaterpeil in de grachten (centrum). Hoe hoog, of laag, is dit waterpeil?",
        "answers": [
          {
            "title": "1.8 meter onder NAP ",
            "correct": false
          },
          {
            "title": "0.4 meter onder NAP ",
            "correct": true
          },
          {
            "title": "0.7 meter onder NAP ",
            "correct": false
          },
          {
            "title": "3.4 meter onder NAP ",
            "correct": false
          }
        ],
        "extra": "Het juiste antwoord is 0.4m onder NAP. Dat is voor iedereen ongeveer het ideale waterpeil. Dit is erg belangrijk. Een te hoog waterpeil zorgt voor natte voeten, maar een te laag waterpeil heeft als risico dat funderingspalen droog komen te liggen en daardoor gaan rotten."
      },
      {
        "id": 6,
        "title": "Welk dier komt niet voor in de grachten?",
        "answers": [
          {
            "title": "Kreeft",
            "correct": false
          },
          {
            "title": "Zalm",
            "correct": false
          },
          {
            "title": "Padden",
            "correct": true
          }
        ],
        "extra": "Door klimaatverandering is er een groot voedseltekort voor dieren in de natuur. De stad trekt daardoor exoten aan: planten, dieren of andere organismes die van nature niet voorkomen in het gebied waar ze zijn. Uiteindelijk is voor een groot aantal dieren de stad net zo aantrekkelijk als een bos of wildernis. "
      },
      {
        "id": 7,
        "title": "Voor een flink aantal grachtentuinen gelden bepaalde regels om ze zo groen mogelijk te houden. Hoe heten deze regels?",
        "answers": [
          {
            "title": "Groenregels",
            "correct": false
          },
          {
            "title": "Keurregels",
            "correct": true
          },
          {
            "title": "Boomregels",
            "correct": false
          }
        ],
        "extra": "Dankzij de 17de-eeuwse keurregels is het groen in de grachtengordel gebleven en kunnen wij hier nog elke dag van genieten! De keurtuinen liggen in de zogenoemde keurblokken. In totaal zijn er 27 keurblokken. Het was ten strengste verboden om in het tuingedeelte industrieën of grote gebouwen te plaatsen. De keurtuinen genieten sinds 1615 speciale wettelijke bescherming."
      },
      {
        "id": 8,
        "title": "Naast de bomen in de grachtentuinen zijn er ook volop bomen op de grachtengordel. Wat voor bomen zijn dit?",
        "answers": [
          {
            "title": "Eiken",
            "correct": false
          },
          {
            "title": "Linden",
            "correct": false
          },
          {
            "title": "Iepen",
            "correct": true
          }
        ],
        "extra": "Dit zijn Amsterdamse iepen! De bomen worden steeds belangrijker om de stad leefbaar te houden. Iepen zijn geschikt voor veel grondsoorten en de boom kan goed overleven in de stad. Meer groen in de stad zorgt voor verkoeling, een grotere biodiversiteit en meer zuurstof. "
      },
      {
        "id": 9,
        "title": "Welke aanpassingen doet de gemeente voor dieren in de stad?",
        "answers": [
          {
            "title": "Struiken en moeras – en waterplanten plaatsen bij kade werkzaamheden",
            "correct": false
          },
          {
            "title": "Planten van varens en waterplanten om insecten te trekken",
            "correct": false
          },
          {
            "title": "Het plaatsen van vleermuisholtes onder bruggen",
            "correct": false
          },
          {
            "title": "Alle antwoorden zijn juist",
            "correct": true
          }
        ],
        "extra": "Deze zwaan bouwde hier haar nest, tussen de tijdelijke damwanden midden in een bijzonder stukje natuur op de grachten. Maar deze natuur bloeide niet van zelf op: er zijn stuiken, viskorven en moeras -en waterplanten geplaatst. "
      }
    ]
    // [{ "id": 0, "title": "Welke vis zal je nooit tegenkomen in de Amsterdamse grachten?", "answers": [{ "title": "Een tonijn", "correct": true }, { "title": "Een snoekbaars", "correct": false }, { "title": "Een paling", "correct": false }, { "title": "Een zalm", "correct": false }], "extra": "" }, { "id": 1, "title": "Hoeveel kilogram plastic haalt Waternet jaarlijks ongeveer uit de Amsterdamse grachten?", "answers": [{ "title": "tussen de 20.000 en 30.000 kilogram", "correct": false }, { "title": "tussen de 40.000 en 60.000 kilogram", "correct": true }, { "title": "Tussen de 70.000 en 90.000 kilogram", "correct": false }, { "title": "Tussen de 90.000 en 110.000 kilogram", "correct": false }], "extra": "" }, { "id": 2, "title": "Door de Gemeente Amsterdam wordt gestreefd naar een vast oppervlaktewaterpeil in de grachten (centrum). Hoe hoog, of laag, is dit waterpeil?", "answers": [{ "title": "1.8 meter onder NAP", "correct": false }, { "title": "0.4 meter onder NAP", "correct": true }, { "title": "0.7m boven NAP", "correct": false }, { "title": "3.4m boven NAP", "correct": false }], "extra": "Het juiste antwoord is 0.4m onder NAP. Dat is voor iedereen ongeveer het ideale waterpeil. Dit luistert heel nauw. Een te hoog waterpeil zorgt voor natte voeten, maar een te laag waterpeil heeft als risico dat funderingspalen droog komen te liggen en daardoor gaan rotten." }, { "id": 3, "title": "Hoe zie je dat de Amsterdamse grachten schoner worden?", "answers": [{ "title": "Er groeien plantjes in en rondom het water van de grachten", "correct": false }, { "title": "Het water is minder troebel dan vroeger", "correct": false }, { "title": "Er leven veel verschillende soorten vissen in het water", "correct": false }, { "title": "Alle antwoorden zijn juist", "correct": true }], "extra": "" }, { "id": 4, "title": "In welk jaar was voor het eerst h\u00e9\u00e9l Amsterdam aangesloten op het riool?", "answers": [{ "title": "1930", "correct": false }, { "title": "2017", "correct": true }, { "title": "1870", "correct": false }], "extra": "" }, { "id": 5, "title": "Wat is een peilbesluit?", "answers": [{ "title": "Een besluit vanuit Rijkswaterstaat en Waterschappen, die eens in de tien jaar gemaakt wordt, over het ideale waterpeil voor iedereen in een gebied.", "correct": true }, { "title": "Een besluit van Waterschappen, bij welke peilhoogte het noodplan in werking moet treden.", "correct": false }, { "title": "Een besluit van gemeenten in een crisissituatie dat er drastische stappen genomen moeten worden om het peil te verlagen.", "correct": false }, { "title": "Een besluit van het Rijk, waarbij er gepeild wordt naar het waterpeil in iedere provincie.", "correct": false }], "extra": "Peilbesluiten worden ongeveer eens in de tien jaar vastgesteld. Hierbij gaan uitvoerende organen van Rijkswaterstaat en Waterschappen in gesprek met alle betrokken partijen om tot de juiste waterhoogte te komen. In Amsterdam-centrum is sinds 2008 een zomer- en winterpeil van 0.4m onder NAP van kracht." }, { "id": 6, "title": "Soms wordt in Amsterdam het rioolwater vermengd met oppervlaktewater in de grachten. Hoe komt dat?", "answers": [{ "title": "Er zijn nog woningen in Amsterdam die hun rioolleidingen direct op de grachten uit laten komen", "correct": false }, { "title": "De riolering raakt af en toe te vol als er teveel mensen tegelijkertijd hun toilet doortrekken", "correct": false }, { "title": "Als het hard geregend heeft kan de riolering het niet aan en kan men niet anders dan het via een overstort op de grachten te lozen", "correct": true }, { "title": "Alle drie de antwoorden zijn juist", "correct": false }], "extra": "Na een zware regenbui stroomt er teveel water de riolen in, waarna het zich vermengt met vervuild water uit huizen. Omdat de grootste nachtmerrie is dat het water omhoog komt in toiletten, wordt er daarom een deel op de grachten geloosd. Dit gebeurt vaak in de zomer. Het zuiveren kost ongeveer drie dagen." }, { "id": 7, "title": "Hoe diep is de gemiddelde Amsterdamse gracht ongeveer?", "answers": [{ "title": "Tussen de \u00e9\u00e9n en twee meter", "correct": false }, { "title": "Tussen de twee en drie meter", "correct": true }, { "title": "Tussen de drie en vier meter", "correct": false }, { "title": "Dat varieert zo sterk dat daar niets over te zeggen valt", "correct": false }], "extra": "" }, { "id": 8, "title": "Amsterdamse grachtenhuizen staan op houten funderingspalen. Maar dan heb je ook nog de riolering\u2026 Hoe zit dat?", "answers": [{ "title": "Het is altijd een hele puzzel om de rioleringsbuizen door de houten funderingspalen heen te leggen.", "correct": false }, { "title": "De houten funderingspalen liggen over het algemeen lager dan de rioleringsbuizen, en daarom kruisen ze elkaar vrijwel nooit.", "correct": true }, { "title": "De rioleringsbuizen liggen over het algemeen lager dan de houten funderingspalen, en daarom kruisen ze elkaar vrijwel nooit.", "correct": false }, { "title": "Het ligt aan de zandlaag waarop de palen rusten, of de rioleringsbuizen hier tussen of er bovenop geplaatst zijn.", "correct": false }], "extra": "" }, { "id": 9, "title": "Welk gemalen en sluizen zijn nodig voor het op peil houden van de Amsterdamse waterstanden?", "answers": [{ "title": "Gemaal IJburg", "correct": false }, { "title": "Gemaal IJmuiden", "correct": false }, { "title": "De sluis onder de Waag", "correct": false }, { "title": "Alle drie de antwoorden zijn juist", "correct": true }], "extra": "" }]
  }
}

export default QuizData;
